'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Faq;
(function (Faq) {
    var MyFaq = /** @class */ (function () {
        function MyFaq() {
            $('.trigFaqWindow').on('click', function (e) {
                if ($(e.currentTarget).next().not(':animated').length >= 1) {
                    $(e.currentTarget).next().slideToggle('fast');
                }
            });
        }
        return MyFaq;
    }());
    Faq.MyFaq = MyFaq;
})(Faq || (Faq = {}));
exports.default = Faq;
